import { useState } from "react";

const useToggle = () => {
  const [isToggled, setIsToggled] = useState(false);

  const toggle = () => {
    setIsToggled((previewsState) => !previewsState);
  };

  return [ isToggled, toggle ];
};
export default useToggle;
